import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {  ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { CommonService } from '../Services/common.service';
import { CardServiceService } from '../Services/card-service.service';
import { AuthService } from '../Services/auth.service';
import { ToastrService } from "ngx-toastr";


@Component({
  selector: "app-month-select",
  templateUrl: "./month-select.component.html",
  standalone:false,
  styleUrls: ["./month-select.component.scss"],
})
export class MonthSelectComponent implements OnInit {
  selectedMonth: string = "";
  Monthlist;
  MonthYear: string = "";
  internalId: string = "";
  AccountType: any;

  constructor(
    private location: Location,
    public commonP: CommonService,
    private cardService: CardServiceService,
    public auth: AuthService,
    public _router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {
     
  }

  async ngOnInit(): Promise<any> {

    // this.Monthlist = [
    //   {
    //     iconClass: "",
    //     displayValue: "January",
    //   },
    //   {
    //     iconClass: "",
    //     displayValue: "Febuary",
    //   }, {
    //     iconClass: "",
    //     displayValue: "March",
    //   }, {
    //     iconClass: "",
    //     displayValue: "April",
    //   }, {
    //     iconClass: "",
    //     displayValue: "May",
    //   }, {
    //     iconClass: "",
    //     displayValue: "June",
    //   }, {
    //     iconClass: "",
    //     displayValue: "July",
    //   }, {
    //     iconClass: "",
    //     displayValue: "August",
    //   }, {
    //     iconClass: "",
    //     displayValue: "September",
    //   }, {
    //     iconClass: "",
    //     displayValue: "October",
    //   }, {
    //     iconClass: "",
    //     displayValue: "November",
    //   }, {
    //     iconClass: "",
    //     displayValue: "December",
    //   }
    // ]
    this.route.queryParams.subscribe((params) => {

      if (params['id']) {

        this.internalId = params['id'];

      }
      if(params['type']){
        this.AccountType = params['type'];
      }
    });
    this.commonP.presentLoading();
    this.cardService.GetCardDates({ InternalId: this.internalId }, this.auth.accessToken).then((data: any) => {
  
      if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          let MonthsList = data.response.content;
          if(MonthsList.length == 0){
          this.commonP.ParseErrorAlert("Sorry", "OK", this._router, "No Data Found");
          }
          else{
            this.Monthlist = MonthsList.map((x) => ({
              displayValue: x.displayValue,
              value: x.value,
            }));
  
          }
          // this.showModal(num);
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  onMonthChange(event) {
    this.selectedMonth = event.displayValue;
    this.MonthYear = event.value;
  }

  back() {
    this.location.back();
  }

  isValid() {
    if (this.selectedMonth) {
      return false;
    } else {
      return true;
    }
  }

  // continue(){
  //   this._router.navigateByUrl("/CardTransactionHistory");
  // }
}
